import React from "react";
import CountUp from "react-countup";
import "../styles/statsStrip.css";

const StatsStrip = () => {
  return (
    <section className="stats-section">
      <div className="container">
        <div className="row g-3 g-md-4 justify-content-center">
          {/* Stat 1 */}
          <div className="col-12 col-md-4">
            <div className="stat-card">
              <div className="stat-number">
                <CountUp end={15} duration={3} suffix="+" enableScrollSpy />
              </div>
              <p className="stat-text">év tapasztalat Szolnokon</p>
            </div>
          </div>

          {/* Stat 2 */}
          <div className="col-12 col-md-4">
            <div className="stat-card">
              <div className="stat-number">
                <CountUp end={9} duration={3} enableScrollSpy />
              </div>
              <p className="stat-text">autó a flottánkban</p>
            </div>
          </div>

          {/* Stat 3 */}
          <div className="col-12 col-md-4">
            <div className="stat-card">
              <div className="stat-number">
                <CountUp end={150} duration={3} enableScrollSpy suffix="+" />
              </div>
              <p className="stat-text">elégedett ügyfél</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsStrip;
